import { jsxs as i, jsx as n } from "react/jsx-runtime";
import d from "react";
import o from "styled-components";
import { R as p, H as l } from "../chunks/Heading.2a0f9b41.js";
import { R as g } from "../chunks/Description.be3b00d1.js";
import { R as m, a as f, I as y } from "../chunks/index.5437e162.js";
const a = o(p).withConfig({
  displayName: "Heading",
  componentId: "sc-pscpyy-0"
})([""]), r = o(g).withConfig({
  displayName: "Description",
  componentId: "sc-pscpyy-1"
})([""]), h = o.div.withConfig({
  displayName: "Container",
  componentId: "sc-pscpyy-2"
})(["display:flex;flex-direction:row;align-items:center;justify-content:center;gap:var(--spacing-2x);padding:var(--spacing-3x);border-radius:var(--border-radius-lg);background-color:var(--informative-bg-color-02);width:100%;min-width:272px;height:100%;box-sizing:border-box;", "{color:var(--on-informative-heading-color);}", "{color:var(--on-informative-description-color);}"], a, r), x = o.div.withConfig({
  displayName: "Content",
  componentId: "sc-pscpyy-3"
})(["display:flex;flex-direction:column;align-items:flex-start;gap:var(--spacing-1x);width:100%;box-sizing:border-box;"]), u = d.forwardRef(({
  heading: t,
  description: e,
  ...c
}, s) => /* @__PURE__ */ i(h, { ref: s, "data-testid": "rango-card-unlock-functionality", "data-rango-component": "rango-card-unlock-functionality", "data-is-rango": !0, ...c, children: [
  /* @__PURE__ */ n(m, { type: f.Informative, icon: "LockLine", size: y.LG }),
  /* @__PURE__ */ i(x, { children: [
    /* @__PURE__ */ n(a, { size: l["2XS"], children: t }),
    /* @__PURE__ */ n(r, { children: e })
  ] })
] }));
u.displayName = "RangoCardUnlockFunctionality";
export {
  u as RangoCardUnlockFunctionality
};
